import psl from 'psl'

const md5 = require('md5')

export const getTimeString = time => {
  return `${time < 10 ? '0' : ''}${time}`
}

export const convertMinsToHrsMins = mins => {
  let h = Math.floor(mins / 60)
  let m = mins % 60

  h = h < 10 ? '0' + h : h
  m = m < 10 ? '0' + m : m

  return `${h}:${m}`
}

export const getDomain = url => {
  const parsedUrl = psl.parse(extractHostname(url))
  const domain = parsedUrl.domain
  const subdomain = parsedUrl.subdomain

  if (subdomain) {
    if (subdomain === 'www') {
      return domain
    }
    else if (subdomain.startsWith('www')) {
      return `${subdomain.slice(4)}.${domain}`
    } else {
      return `${subdomain}.${domain}`
    }
  } else {
    return domain
  }
}

// @see https://stackoverflow.com/questions/8498592/extract-hostname-name-from-string/16934798
export const extractHostname = url => {
  let hostname

  if (url.indexOf("//") > -1) {
    hostname = url.split('/')[2]
  } else {
    hostname = url.split('/')[0]
  }

  hostname = hostname.split(':')[0]
  hostname = hostname.split('?')[0]

  return hostname;
}

export const fingerprint = () => {
  let buff = ''

  for (let x in navigator) {
    if (typeof navigator[x] === 'string') {
      buff += navigator[x]
    }
  }

  return md5(buff)
}


export const userOS = () => {
  let OSName = ''

  if (navigator.appVersion.indexOf("Win") != -1) {
    OSName = "Windows"
  }

  if (navigator.appVersion.indexOf("Mac") != -1) {
    OSName = "Mac"
  }

  if (navigator.appVersion.indexOf("Linux") != -1) {
    OSName = "Linux"
  }

  return OSName
}

export const isMobileDevice = () => {
  return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1)
}

export const skipDuplicates = (arr) => {
  return _.map(
    _.uniq(
        _.map(arr, obj => {
            return JSON.stringify(obj)
        })
    ), obj => {
        return JSON.parse(obj)
    }
  )
}

export const filter = (array = [], keyword = '', prop = null) => {
  if (!prop) {
    return array.filter(item => item.toLowerCase().includes(keyword.toLowerCase()))
  }

  return array.filter(item => {
    return item[prop].toLowerCase().includes(keyword.toLowerCase())
  })
}